<div class="core-header-div">
  <core-header-bar class="core-header"></core-header-bar>
</div>

<div class="pending-div">
        <div class="mat-headline-5">{{'PendingApproval.Welcome' | translate}}</div>
        <div class="mat-subtitle-1">
                {{'PendingApproval.Message' | translate}}
        </div>
</div>